window._ = require('lodash');

window.Vue = require('vue');
window.swal = require('sweetalert'); // アラート（confirm）ライブラリ
window.moment = require('moment'); // 日付ライブラリ
window.bootstrap = require('bootstrap');

require('spectrum-colorpicker');

// import css
import 'spectrum-colorpicker/spectrum.css';
import 'suneditor/src/assets/css/suneditor.css';
import 'suneditor/src/assets/css/suneditor-contents.css';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('@popperjs/core').default;
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {
    console.error(e);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// ヤフーtokenが必要なリクエストはyahooAxiosを使用すること
window.yahooAxios = axios.create();
window.yahooAxios.interceptors.request.use(async function (config) {
    console.log('yahooAxios: isValidToken');
    try {
        const res = await axios.post('/yahoo_auth/is_valid_token', {
            _method: 'GET',
        });
        if (res.data.result === true && res.data.status === 'OK') {
            return config;
        }
        return Promise.reject(res);
    } catch (e) {
        return Promise.reject(e);
    }
});


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

/**
 * SweetAlertの拡張
 * デフォルト値設定が無いのでメソッドで拡張する
 */
window.swalConfirm = function (text) {
    return swal({
        text: text,
        buttons: {
            cancel: {
                text: 'キャンセル',
                visible: true,
            },
            confirm: {
                text: 'OK',
                visible: true,
            }
        },
        dangerMode: true,
        closeOnClickOutside: false,
        closeOnEsc: false,
    });
};

/**
 * momentjsのインスタンスを作成する
 * @param {string|Date} date - 作成する日付
 * @returns {moment} - 作成された日付
 */
window.createMoment = function (date) {
    if (!date || (typeof date === 'object' && date.constructor !== Date)) return null;
    if (typeof date === 'string') {
        date = new Date(date);
    }

    return Number.isInteger(date.getTime()) ? moment(date) : null;
};

import { Fragment, Comment, Text } from 'vue';

/**
 * Vue3対応Node空チェック
 * @param {Object|Array} vnodes - ノード
 * @returns {boolean} - ノードが空かどうか
 */
window.isVNodeEmpty = function (vnodes) {
    if (typeof vnodes === 'object' && vnodes.constructor !== Array) vnodes = [vnodes];
    return vnodes.every(node =>
        node.type === Comment ||
        (node.type === Text && !node.children.trim()) ||
        (node.type === Fragment && isVNodeEmpty(node.children))
    );
};

/**
 * Vue3対応スロット使用チェック
 * @param {Object} slot - スロット(this.$slots)
 * @param {string} name - スロット名
 * @returns {boolean} - スロットが空かどうか
 */
window.isSlotEmpty = function (slot, name = 'default') {
    return (
        typeof slot === 'undefined' ||
        typeof slot[name] !== 'function' ||
        isVNodeEmpty(slot[name]())
    );
};
